<!-- src/components/ParkingModal.vue -->
<template>
  <div class="modal" v-if="visible">
    <div class="modal-content">
      <div class='park-photo-div'>
        <img :src="getFullImageURL(parking.photo_url)" alt="Parking Lot" @error="onImageError" />
        <span class="close" @click="closeModal">&times;</span>
        <!-- Navigation Icon -->
        <div class="navigation-icon" @click="navigateToParking">
          <i class="fas fa-location-arrow"></i> <!-- Font Awesome icon -->
        </div>
      </div>
      <h3>{{ parking.title }}</h3>
      <div class="park-type-line">
        <!-- <div class="park-num">{{ parking.total_space }} 個車位</div> -->
        <div class="park-type" v-for="(type, index) in getParkingType(parking)" :key="index">
          {{ type }}
        </div>
      </div>
    <label>地址</label>
    <p>{{ paddingBlank(parking.address) }}</p>
    <label>電話</label>
    <p>{{ paddingBlank(parking.contact_phone) }}</p>
      <label>場地限高</label>
      <!-- <p>{{ parking.max_height }}M</p> -->
      <p>
        {{ parking.max_height !== null ? parking.max_height + 'M' : 'N/A' }}
      </p>
    <label>特約商店</label>
    <p>{{ paddingBlank(parking.partner_store) }}</p>      
      <label>支付方式</label>
      <!-- <p>{{ parking.payment_method }}</p> -->
      <!-- <p>{{ parking.payment_method.replace('#$%', ',') }}</p> -->
      <p>{{ getPaymentMethod(parking) }}</p>
      <div class="payment-buts">
        <button class='payment-but' @click="proceedToPayment">線上繳費</button>
        <button v-if="parking.is_rent" class='payment-but monthly-rental-but' @click="applyMonthlyRental">申請月租</button>
      </div>
    </div>
  </div>
</template>

<script>
import { onImageError, getParkingType, getPaymentMethod, getFullImageURL,paddingBlank } from '@/util/util';
import { navigateToParking } from '@/util/map';

export default {
  name: 'ParkingModal',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    parking: {
      type: Object,
      required: true
    }
  },
  methods: {
    paddingBlank,
    getPaymentMethod,
    navigateToParking,
    getFullImageURL,
    onImageError,
    getParkingType,
    closeModal() {
      this.$emit('close');
    },
    proceedToPayment() {
      this.$emit('proceed');
    },
    applyMonthlyRental() {
      this.$emit('apply-monthly-rental');
      // this.$emit('monthlyRental');
      //goto UserApply page
    } 
  },


};
</script>

<style scoped>
.modal {
  position: fixed;
  display: block;
  /* position: fixed; */
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);

  z-index: 1000;
}

.modal-content {
  transform: scale(0.8);
  transform-origin: top;

  position: absolute;
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: #fefefe;
  align-items: left;
  text-align: left;
  justify-content: center;
  margin: 4vh auto;
  /* margin: 10% auto; */
  /* top:397px; */
  border-radius: 12px;
  padding: 16px;
  border: 1px solid #888;
  width: 440px;
  /* height: 640px; */
  box-sizing: border-box;

  /* top: 397.25px; */
}



.park-photo-div {
  position: relative;
  width: 408px;
  height: 200px;
  /* top: 16px; */
  /* left: 16px; */
  border-radius: 12px;

}

.park-photo-div img {
  width: 100%;
  height: 100%;

  border-radius: 12px;

  object-fit: cover;
  /* Ensures the image covers the container, cropping as needed */

}


.close {
  position: absolute;
  top: 8px;
  /* Positioning near the top-right corner of the image */
  right: 8px;
  background-color: white;
  /* Semi-transparent gray background */
  color: black;

  font-weight: 100;
  font-size: 24px;
  font-weight: bold;
  padding: 4px 8px;
  /* Padding around the "X" */
  border-radius: 50%;
  /* Makes it a circle */
  cursor: pointer;
  text-align: center;
  line-height: 1;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}


.navigation-icon {
  position: absolute;
  bottom: -80px;
  right: 8px;
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background-color: var(--green03);
  /* Adjust to match your theme */
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.navigation-icon i {
  color: white;
  /* Icon color */
  font-size: 20px;
  /* Adjust icon size */
}

.navigation-icon:hover {
  transform: scale(1.1);
  /* Hover effect */
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.3);
  /* Enhanced shadow on hover */
}

@keyframes pulse {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }

  50% {
    transform: scale(1.15);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.3);
  }

  100% {
    transform: scale(1);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  }
}

.navigation-icon {
  animation: pulse 1.5s infinite ease-in-out;
  /* Pulsing animation */
}


h3 {
  margin-top: 12px;
  margin-bottom: 0px;
  font-family: Inter;
  font-size: 24px;
  font-weight: 700;
  line-height: 33.6px;
  text-align: left;

  color: var(--gray15);
}

.park-type-line {
  display: flex;
  flex-direction: row;
  align-items: center;
  /* margin-top: 12px; */
}

.park-num {
  font-family: Inter;
  font-size: 16px;
  font-weight: 700;
  line-height: 22.4px;
  text-align: left;

  color: var(--green03);
}


.park-type {

  padding: 4px 6px 4px 6px;

  margin-right: 10px;

  font-family: Inter;
  font-size: 12px;
  font-weight: 700;
  line-height: 18.48px;
  text-align: left;



  border-radius: 8px;

  background-color: var(--green05);
  color: white;
}


.modal-content label {
  font-family: Inter;
  font-size: 12px;
  font-weight: 400;
  line-height: 18.48px;
  text-align: left;


  margin-top: 10px;

  color: var(--gray11);
}

.modal-content p {
  font-family: Inter;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-align: left;

  color: var(--gray13);
  margin-top: 2px;
  margin-bottom: 4px;

}



.payment-but {
  margin-top: 18px;
  border: none;
  cursor: pointer;
  width: 100%;

  width: 408px;
  height: 58px;
  min-height: 48px;
  padding: 16px 32px 16px 32px;
  border-radius: 99px;

  font-family: Inter;
  font-size: 18px;
  font-weight: 700;
  line-height: 26.1px;
  text-align: center;



  background-color: var(--green03);
  color: white;

}

.monthly-rental-but {
  margin-top: 12px;
  background-color: white;
  color: var(--green03);
  border: 1px solid var(--green03);
}

@media screen and (max-width: 560px) {
  .modal-content {

    /*cancel transform: scale(0.8); */
    
    transform: none;
    transform-origin: top;


    width: 343px;
    margin: 30px auto;
    padding: 12.5px;
  }

  .modal-content label {

  margin-top:4px;
}


  .park-photo-div {
    width: 318.05px;
    height: 200px;
  }

  .park-photo-div img {
    width: 100%;
    height: 100%;
  }

  .close {
    top: 8px;
    right: 8px;
  }


  .payment-buts {
    display: flex;
    flex-direction: row-reverse;
    gap: 10px;
    margin-top: 10px;
    margin-bottom: 0px;
    align-items: center;
  }

  .max-height {
    display: none;

  }

  .payment-but {
    margin-top: 0px;
    width: 100%;
  }

}
</style>